<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="700XAuto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>批量修改成本</template>
    <template #content>
      <div class="flex">
        <div class="labels">{{ skuNumStr }}</div>
        <div style="padding-left: 12px;">

          <gj-tooltip :text-line="3">
            <template #content>
              <div class="tool-box">
                {{skuStr}}
              </div>
            </template>
            {{skuStr}}
          </gj-tooltip>

        </div>
      </div>
      <div class="flex align-center" style="padding-top: 16px;">
        <div class="labels">统一修改为：</div>
        <div style="padding-left: 12px;">
          <el-form ref="form" :model="form" :inline="true" class="demo-form-inline">
            <el-form-item label="采购成本">
              <gj-input v-model="form.purchaseCost" class="form-input" width="120px" maxlength="13" v-number.toFixed4>
                <template #prepend>
                  ￥
                </template>
              </gj-input>
            </el-form-item>
            <el-form-item label="到库成本" label-width="90px">
              <gj-input v-model="form.inventoryCost" class="form-input" width="120px" maxlength="13" v-number.toFixed4>
                <template #prepend>
                  ￥
                </template>
              </gj-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

<!--      <el-row>-->
<!--        <el-col :span="6" class="text-right">-->
<!--          <span>{{ skuNumStr }}</span>-->
<!--        </el-col>-->
<!--        <el-col :offset="1" :span="15" class="text-left">-->
<!--          <gj-tooltip :text-line="3" :content="skuStr">{{skuStr}}</gj-tooltip>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <br>-->
<!--      <el-row>-->
<!--        <el-col :span="6" class="text-right mar-top">-->
<!--          <span>统一修改为：</span>-->
<!--        </el-col>-->
<!--        <el-col :offset="1" :span="15" class="text-left">-->
<!--          <el-form ref="form" :model="form" :inline="true" class="demo-form-inline">-->
<!--            <el-form-item label="采购成本">-->
<!--              <gj-input v-model="form.purchaseCost" class="form-input" width="120px" maxlength="13" v-number.toFixed4>-->
<!--                <template #prefix>-->
<!--                  ￥-->
<!--                </template>-->
<!--              </gj-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="到库成本" label-width="90px">-->
<!--              <gj-input v-model="form.inventoryCost" class="form-input" width="120px" maxlength="13" v-number.toFixed4>-->
<!--                <template #prefix>-->
<!--                  ￥-->
<!--                </template>-->
<!--              </gj-input>-->
<!--            </el-form-item>-->
<!--          </el-form>-->
<!--        </el-col>-->
<!--      </el-row>-->

    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "../../../../minxins";
import {batchUpdateFBAMonthCost, batchUpdateMonthCost} from "../../../../api/finance";
import {isMeaningful} from "@/utils/common";
import {convertToFullDate} from "@/utils/date.util";

export default {
  name: "cost-batch-edit",
  mixins: [modalMixIn],
  props: {
    type: {
      required: true,
      type: String
    },
    rows: {
      required: true
    },
    date: {
      required: true
    }
  },
  created() {

    if (this.type === 'sku') {
      this.skuNumStr = `SKU（${this.rows.length}个）：`;
      this.skuStr = this.rows.map(i => i[this.type]+`（${i.warehouseName}）`).join();
    } else {
      this.skuNumStr = `MSKU（${this.rows.length}个）：`;
      this.skuStr = this.rows.map(i => i[this.type]).join();
    }
  },
  data() {
    return {
      confirmLoading: false,
      skuStr: '',
      skuNumStr: '',
      form: {
        purchaseCost: null,
        inventoryCost: null
      }
    }
  },
  methods: {
    confirm() {
      if(this.rows.length === 0){
        this.$message.error("没有可修改的数据！");
        return false;
      }
      let ids = this.rows.map(i => i.id);
      if(!this.form.purchaseCost){
         this.$message.error("请填写采购成本！");
         return false;
      }else{
        let value = this.form.purchaseCost.split('.')[0]+'';
        if(value.length > 8){
          this.$gjMessage.error('请输入正确的数值，保留四位小数');
          return false;
        }
      }
      if(!this.form.inventoryCost){
        this.$message.error("请填写到库成本！");
        return false;
      }else{
        let value = this.form.inventoryCost.split('.')[0]+'';
        if(value.length > 8){
          this.$gjMessage.error('请输入正确的数值，保留四位小数');
          return false;
        }
      }
      this.confirmLoading = true;
      //fba仓
      if(this.type === 'msku'){
        let param = this.rows.map(i => {
          return {
            id: i.id,
            purchaseCost: this.form.purchaseCost,
            inventoryCost: this.form.inventoryCost,
            warehouseId: i.warehouseId,
            msku: i.msku,
            monthDate: this.date,
          }
        })
        batchUpdateFBAMonthCost(param)
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('updated');
            })
            .complete(() => this.confirmLoading = false);
      }
      //自营仓
      else if(this.type === 'sku'){
        batchUpdateMonthCost({
          ids, ...this.form
        })
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('updated');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
.labels{
  flex: none;
  width: 115px;
  text-align: right;
}

.el-form-item{
  margin-bottom: 0;
}
.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.mar-top {
  margin-top: 4px;
}
.tool-box{
  overflow: auto;
  max-height: 200px;
  padding-right: 10px;
  margin-right: -10px;
  &::-webkit-scrollbar-track{
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb{
    background-color: #666;
  }
  &::-webkit-scrollbar{
    width: 4px;
  }
}

</style>
